import React, {useState, Suspense} from 'react';

import ErrorBoundary from "../ErrorBoundary"


// Dynamic Import
const loadWidget = (objet, id) => {
        return React.lazy(
            async () => {
                let obj;
                try {
                    obj = await import(`./Objets/${objet}/${objet}.js`)
                } catch (e){
                    console.error(`Cannot find module ${objet} in ObjetElementaire.js`)
                    obj = (<p>ID : {id} not found </p>)
                }
                return obj;
            }
        );
}

const Widget = ({idObjet, typeObjet}) => {
    const [ObjectComponent] = useState(loadWidget(typeObjet, idObjet));

    return (
        <ErrorBoundary>
            <Suspense fallback={<>Loading</>}>
                <div className="filigraneWidgetDraggable"></div>
                <ObjectComponent idObjet={idObjet}/>
            </Suspense>
        </ErrorBoundary>
    )
};

export default Widget;
